const React = require('react');
const { TooltipPanel } = require('@reverbdotcom/discovery-ui');
const APIRequest = require('components/api_request.js');
const BulkCuratedSetItem = require('./bulk_curated_set_item.jsx');
const Spinner = require('components/shared/spinner.jsx');

class BulkSaleButton extends React.Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.loadCuratedSets();
  }

  handleClose() {
    // we want to reload the data on next open
    this.setState({ loaded: false });
  }

  loadCuratedSets() {
    APIRequest.V3.get(`/api/my/listings/curated_sets${window.location.search}`,).then((response) => {
      this.setState({
        curatedSets: response.curated_sets,
        loaded: true,
      });
    });
  }

  renderSets() {
    return this.state.curatedSets.map(set =>
      (<BulkCuratedSetItem
        curatedSet={set}
        key={set.id}
      />),);
  }

  renderPanel() {
    if (!this.state.loaded) {
      return (
        <Spinner />
      );
    }

    if (this.state.curatedSets.length === 0) {
      return (
        <div className="small center">
          {I18n.t('js.dashboard.selling.bulkSale.noSales')}
          <br />
          <a href="/my/selling/sales">
            {I18n.t('js.dashboard.selling.bulkSale.createASale')}
          </a>
        </div>
      );
    }

    return (
      <div>
        <h4 className="heading-4 center mb-1">{I18n.t('js.dashboard.selling.bulkSale.header')}</h4>
        {this.renderSets()}
      </div>
    );
  }

  render() {
    return (
      <div className="bulk-sale-dropdown">
        <TooltipPanel
          triggerProps={{
            className: 'btn btn-small',
            children: <span className="icon-l-tag icon-r-caret-down">{I18n.t('js.dashboard.selling.bulkSale.sale')}</span>,
          }}
          align="left"
          className="tooltip-panel--medium"
          onOpen={this.handleOpen}
          onClose={this.handleClose}
        >
          {this.renderPanel()}
        </TooltipPanel>
      </div>
    );
  }
}

module.exports = BulkSaleButton;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/listings_manager/sales/bulk_sale_button.jsx